/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Renamefailed1Inputs */

const zh_sidebar_renamefailed1 = /** @type {(inputs: Sidebar_Renamefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重命名失败`)
};

const en_sidebar_renamefailed1 = /** @type {(inputs: Sidebar_Renamefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename failed`)
};

const es_sidebar_renamefailed1 = /** @type {(inputs: Sidebar_Renamefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al renombrar`)
};

/**
* | output |
* | --- |
* | "Rename failed" |
*
* @param {Sidebar_Renamefailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_renamefailed1 = /** @type {((inputs?: Sidebar_Renamefailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Renamefailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_renamefailed1(inputs)
	if (locale === "en") return en_sidebar_renamefailed1(inputs)
	return es_sidebar_renamefailed1(inputs)
});
export { sidebar_renamefailed1 as "sidebar_renameFailed" }